import { FC } from "react";

import { Box } from "@chakra-ui/react";

import Icon from "@components/Icon";
import Message from "@components/Message";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../../hooks/useOrderFormik";

const ArrivalMessage: FC = () => {
  const {
    values: { [OrderFields.DELIVERY_METHOD]: deliveryMethod },
  } = useOrderFormik();

  const {
    dynamicData: { offers },
  } = useOrderData();

  const selectedOffer = offers.find(
    ({ deliveryMethod: offerDeliveryMethod }) => offerDeliveryMethod === deliveryMethod
  );

  if (!selectedOffer?.serviceDuration) {
    return null;
  }

  return (
    <Message align="start" icon={<Icon icon="info" size="1.25rem" />} sx={{ py: "0.7rem" }}>
      <Box>{selectedOffer.serviceDuration}</Box>
    </Message>
  );
};
export default ArrivalMessage;
